var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/runtime-contract/index.ts
var runtime_contract_exports = {};
__export(runtime_contract_exports, {
  Incoming: () => incoming_exports,
  LoginEvent: () => LoginEvent,
  Outgoing: () => outgoing_exports,
  WorkflowEvent: () => WorkflowEvent
});

// src/runtime-contract/outgoing/index.ts
var outgoing_exports = {};
__export(outgoing_exports, {
  OutgoingMessages: () => OutgoingMessages,
  VimConnectUIMessageType: () => VimConnectUIMessageType
});

// src/runtime-contract/outgoing/messages.ts
var OutgoingMessages = /* @__PURE__ */ ((OutgoingMessages2) => {
  OutgoingMessages2["SEND_EVENT"] = "vim-connect-event";
  OutgoingMessages2["WIDGET_DATA_TO_APP"] = "vim-connect-widget-data-to-app";
  OutgoingMessages2["INITIALIZE_DATA"] = "vim-connect-initialize-data";
  OutgoingMessages2["INITIALIZE_ME"] = "vim-connect-initialize-me";
  OutgoingMessages2["GET_HOSTNAME"] = "vim-connect-get-hostname";
  OutgoingMessages2["UPDATE_ACCESS_TOKEN"] = "vim-connect-update-access-token";
  OutgoingMessages2["DATA_TO_VIM_CONNECT_UI"] = "vim-connect-data-to-vim-connect-ui";
  OutgoingMessages2["ON_LOGOUT"] = "vim-connect-logout";
  OutgoingMessages2["SET_LOGGER_USER_METADATA"] = "set-logger-user-metadata";
  OutgoingMessages2["RUNTIME_LOGIN_FAILED"] = "vim-connect-runtime-login-failed";
  return OutgoingMessages2;
})(OutgoingMessages || {});
var VimConnectUIMessageType = /* @__PURE__ */ ((VimConnectUIMessageType2) => {
  VimConnectUIMessageType2["InjectApplication"] = "platform-inject-application";
  VimConnectUIMessageType2["ModifyApplication"] = "platform-modify-application";
  VimConnectUIMessageType2["SelectApplication"] = "platform-select-application";
  VimConnectUIMessageType2["RemoveApplication"] = "platform-remove-application";
  VimConnectUIMessageType2["SendDataToWidget"] = "platform-send-data-to-widget";
  return VimConnectUIMessageType2;
})(VimConnectUIMessageType || {});

// src/runtime-contract/incoming/index.ts
var incoming_exports = {};
__export(incoming_exports, {
  IncomingMessages: () => IncomingMessages,
  IncomingVimOsMessages: () => IncomingVimOsMessages,
  VimConnectUI: () => vim_connect_ui_exports
});

// src/runtime-contract/incoming/messages.ts
var IncomingVimOsMessages = /* @__PURE__ */ ((IncomingVimOsMessages2) => {
  IncomingVimOsMessages2["EXECUTE_ACTION"] = "vim-os-to-runtime-execute-action";
  IncomingVimOsMessages2["EXECUTE_WRITE_BACK"] = "vim-os-to-runtime-execute-write-back";
  IncomingVimOsMessages2["HUB_WIDGET_POSITION_CHANGED"] = "vim-os-to-runtime-hub-widget-position-changed";
  IncomingVimOsMessages2["INJECT_LAUNCH_BUTTON"] = "vim-os-to-runtime-inject-launch-button";
  IncomingVimOsMessages2["ANALYTICS_TRACK"] = "vim-os-to-runtime-analytics-track";
  IncomingVimOsMessages2["ANALYTICS_SET_BASE_PROPERTIES"] = "vim-os-to-runtime-analytics-set-base-properties";
  IncomingVimOsMessages2["ANALYTICS_SET_SESSIONS"] = "vim-os-to-runtime-analytics-set-sessions";
  IncomingVimOsMessages2["APP_ANALYTICS_TRACK"] = "vim-os-to-runtime-app-analytics-track";
  IncomingVimOsMessages2["CLEAR_ME_REQUEST"] = "vim-os-to-runtime-clear-me-request";
  return IncomingVimOsMessages2;
})(IncomingVimOsMessages || {});
var IncomingMessages = /* @__PURE__ */ ((IncomingMessages2) => {
  IncomingMessages2["ACCESS_TOKEN"] = "vim-connect-access-token";
  IncomingMessages2["GET_APP_DATA"] = "vim-connect-vim-get-app-data";
  IncomingMessages2["GET_SEAMLESS_AUTH_TOKEN"] = "vim-connect-vim-get-seamless-auth-token";
  IncomingMessages2["ANALYTICS_TRACK"] = "analytics-track";
  IncomingMessages2["ANALYTICS_SET_BASE_PROPERTIES"] = "analytics-set-base-properties";
  IncomingMessages2["ANALYTICS_SET_SESSIONS"] = "analytics-set-sessions";
  IncomingMessages2["APP_INITIALIZED"] = "vim-connect-on-initialize";
  IncomingMessages2["COPY_TO_CLIPBOARD"] = "vim-connect-copy-to-clipboard";
  IncomingMessages2["EHR_API"] = "vim-connect-ehr-api";
  IncomingMessages2["INJECT_VIM_CONNECT_UI_APP"] = "vim-connect-ui-inject-app";
  IncomingMessages2["INJECT_WIDGET"] = "vim-connect-inject-widget";
  IncomingMessages2["REMOVE_WIDGET"] = "vim-connect-remove-widget";
  IncomingMessages2["LISTEN_TO_EVENT"] = "vim-connect-listen-to-event";
  IncomingMessages2["LOGIN_FAILED"] = "vim-connect-login-failed";
  IncomingMessages2["ON_LOGIN_APP_DISPLAYED"] = "vim-connect-on-login-app-displayed";
  IncomingMessages2["ON_LOGIN_APP_NOT_DISPLAYED"] = "vim-connect-on-login-app-not-displayed";
  IncomingMessages2["ON_EHR_USER_NOT_EXISTS"] = "vim-connect-on-ehr-user-not-exists";
  IncomingMessages2["MODIFY_VIM_CONNECT_UI_APP"] = "vim-connect-ui-modify-app";
  IncomingMessages2["MODIFY_WIDGET"] = "vim-connect-modify-widget";
  IncomingMessages2["REMOVE_VIM_CONNECT_UI_APP"] = "vim-connect-ui-remove-app";
  IncomingMessages2["RUN_ACTION"] = "vim-connect-run-actions";
  IncomingMessages2["SELECT_VIM_CONNECT_UI_APP"] = "vim-connect-ui-select-app";
  IncomingMessages2["SEND_DATA_TO_WIDGET"] = "vim-connect-send-data-to-widget";
  IncomingMessages2["SEND_DATA_TO_WIDGET_VIM_CONNECT_UI_APP"] = "vim-connect-ui-send-data-to-widget";
  IncomingMessages2["STORAGE_SET"] = "vim-connect-storage-set";
  IncomingMessages2["TRIGGER_SSO_LOGIN"] = "trigger-sso-login";
  IncomingMessages2["WRITE_BACK"] = "vim-connect-write-back";
  IncomingMessages2["DEVICE_ID"] = "vim-connect-device-id";
  IncomingMessages2["IS_OUTDATED"] = "vim-connect-outdateness-query";
  IncomingMessages2["EHR_EVENT"] = "vim-connect-ehr-event";
  IncomingMessages2["INCOMING_VIM_OS_HUB_WIDGET_DATA"] = "vim-connect-incoming-from-os-hub-widget-data";
  IncomingMessages2["TRIGGER_RELOGIN"] = "vim-connect-trigger-relogin";
  IncomingMessages2["REMOVE_USER_TOKENS_FROM_STORAGE"] = "vim-connect-remove-user-tokens-from-storage";
  return IncomingMessages2;
})(IncomingMessages || {});

// src/runtime-contract/incoming/payloads/vim-connect-ui/index.ts
var vim_connect_ui_exports = {};

// src/runtime-contract/event.ts
var LoginEvent = /* @__PURE__ */ ((LoginEvent3) => {
  LoginEvent3["onLoggedIn"] = "onLoggedIn";
  LoginEvent3["onReLogin"] = "onReLogin";
  LoginEvent3["logout"] = "logout";
  return LoginEvent3;
})(LoginEvent || {});
var WorkflowEvent = /* @__PURE__ */ ((WorkflowEvent2) => {
  WorkflowEvent2["patientInContext"] = "patientInContext";
  WorkflowEvent2["claimStarted"] = "claimStarted";
  WorkflowEvent2["claimExited"] = "claimExited";
  WorkflowEvent2["claimUpdated"] = "claimUpdated";
  WorkflowEvent2["patientOutOfContext"] = "patientOutOfContext";
  WorkflowEvent2["patientChartOpened"] = "patientChartOpened";
  WorkflowEvent2["patientChartClosed"] = "patientChartClosed";
  WorkflowEvent2["patientSaved"] = "patientSaved";
  WorkflowEvent2["referralViewed"] = "referralViewed";
  WorkflowEvent2["encounterStart"] = "encounterStart";
  WorkflowEvent2["encounterUpdated"] = "encounterUpdated";
  WorkflowEvent2["encounterExit"] = "encounterExit";
  WorkflowEvent2["referralClosed"] = "referralClosed";
  WorkflowEvent2["referralSaved"] = "referralSaved";
  WorkflowEvent2["referralDeleted"] = "referralDeleted";
  WorkflowEvent2["orderCreated"] = "orderCreated";
  WorkflowEvent2["orderViewed"] = "orderViewed";
  WorkflowEvent2["orderClosed"] = "orderClosed";
  WorkflowEvent2["ordersViewed"] = "ordersViewed";
  WorkflowEvent2["ordersClosed"] = "ordersClosed";
  WorkflowEvent2["sendAnalytics"] = "sendAnalytics";
  WorkflowEvent2["corruptedEhrState"] = "corruptedEhrState";
  WorkflowEvent2["sendEhrData"] = "sendEhrData";
  return WorkflowEvent2;
})(WorkflowEvent || {});

// src/analytics/index.ts
var analytics_exports = {};
__export(analytics_exports, {
  track: () => track
});
var track = async (data, accessToken, deviceId) => {
  const options = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      ...accessToken ? { authorization: accessToken } : void 0,
      ...deviceId ? { ["x-vim-device-id"]: deviceId } : void 0,
      "Content-Type": "application/json"
    }
  };
  return fetch(`/api/info/save`, options);
};

// src/standard/index.ts
var standard_exports = {};
__export(standard_exports, {
  Actions: () => actions_exports,
  ActionsTransformers: () => actions_transformers_exports,
  Connectors: () => connectors_exports,
  Entities: () => entities_exports,
  ErrorCodes: () => ErrorCodes,
  Errors: () => errors_exports,
  Events: () => events_exports,
  Secrets: () => secrets_exports,
  WriteBacks: () => write_backs_exports
});

// src/standard/actions/index.ts
var actions_exports = {};
__export(actions_exports, {
  ActionNames: () => ActionNames
});
var ActionNames = /* @__PURE__ */ ((ActionNames2) => {
  ActionNames2["GET_PATIENT"] = "GET_PATIENT";
  ActionNames2["GET_ENCOUNTER_DATA"] = "GET_ENCOUNTER_DATA";
  ActionNames2["GET_ENCOUNTER_CPTS"] = "GET_ENCOUNTER_CPTS";
  ActionNames2["SEARCH_PROVIDERS"] = "SEARCH_PROVIDERS";
  ActionNames2["GET_CURRENT_EHR_USER_INFORMATION"] = "GET_CURRENT_EHR_USER_INFORMATION";
  ActionNames2["NAVIGATE_TO_ENCOUNTER"] = "NAVIGATE_TO_ENCOUNTER";
  ActionNames2["GET_PROVIDER_DAILY_SUMMARY"] = "GET_PROVIDER_DAILY_SUMMARY";
  ActionNames2["GET_PATIENT_SCHEDULED_APPOINTMENTS"] = "GET_PATIENT_SCHEDULED_APPOINTMENTS";
  ActionNames2["FIND_PATIENT"] = "FIND_PATIENT";
  ActionNames2["PRINT_ENCOUNTER"] = "PRINT_ENCOUNTER";
  ActionNames2["PRINT_ENCOUNTERS"] = "PRINT_ENCOUNTERS";
  ActionNames2["GET_PATIENT_ENCOUNTERS"] = "GET_PATIENT_ENCOUNTERS";
  ActionNames2["GET_ENCOUNTER_LAB_RESULTS"] = "GET_ENCOUNTER_LAB_RESULTS";
  ActionNames2["GET_ENCOUNTER_VITALS"] = "GET_ENCOUNTER_VITALS";
  ActionNames2["GET_PROVIDER_APPOINTMENTS"] = "GET_PROVIDER_APPOINTMENTS";
  ActionNames2["GET_GAPS_FROM_SHARED_REQUEST"] = "GET_GAPS_FROM_SHARED_REQUEST";
  ActionNames2["SUBSCRIBE_TELEVISIT"] = "SUBSCRIBE_TELEVISIT";
  ActionNames2["UNSUBSCRIBE_TELEVISIT"] = "UNSUBSCRIBE_TELEVISIT";
  ActionNames2["GET_INFORMATION"] = "GET_INFORMATION";
  ActionNames2["GET_PATIENT_MEDICATION"] = "GET_PATIENT_MEDICATION";
  ActionNames2["GET_PATIENT_ALLERGIES"] = "GET_PATIENT_ALLERGIES";
  ActionNames2["GET_PATIENT_PROBLEM_LIST"] = "GET_PATIENT_PROBLEM_LIST";
  ActionNames2["GET_PATIENT_LAB_RESULTS"] = "GET_PATIENT_LAB_RESULTS";
  ActionNames2["GET_PATIENT_VITALS"] = "GET_PATIENT_VITALS";
  return ActionNames2;
})(ActionNames || {});

// src/standard/actions-transformers/index.ts
var actions_transformers_exports = {};
__export(actions_transformers_exports, {
  GET_PATIENT: () => GET_PATIENT
});

// src/standard/actions-transformers/get-patient.ts
import { logger as logger3 } from "@getvim/vim-connect-logger";

// src/runtime-contract/outgoing/payloads-transformers/transformers/utils/set-vim-patient-id.ts
import NodeCache from "node-cache";

// src/infra/common/api/patient/get-vim-patient-id.ts
import { logger } from "@getvim/vim-connect-logger";
import gql from "graphql-tag";

// src/infra/common/gql-client.ts
import {
  ApolloClient
} from "apollo-client";
import { ApolloLink } from "apollo-link";
import { createHttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import { setContext } from "apollo-link-context";
import { RetryLink } from "apollo-link-retry";

// src/standard/errors/index.ts
var errors_exports = {};
__export(errors_exports, {
  ActionFailed: () => ActionFailed,
  ActionNotSupported: () => ActionNotSupported,
  AppointmentAlreadyBooked: () => AppointmentAlreadyBooked,
  BadGateway: () => BadGateway,
  CopyToClipboardFailed: () => CopyToClipboardFailed,
  CreateAppointmentFailed: () => CreateAppointmentFailed,
  CreatePatientFailed: () => CreatePatientFailed,
  EhrDown: () => EhrDown,
  InternalError: () => InternalError,
  InvalidInput: () => InvalidInput,
  LocationNotFound: () => LocationNotFound,
  NotFound: () => NotFound,
  OrganizationConfigIsInvalid: () => OrganizationConfigIsInvalid,
  PatientNotFoundError: () => PatientNotFoundError,
  ProviderNotFoundError: () => ProviderNotFoundError,
  ResourceNotFound: () => ResourceNotFound,
  ServiceUnavailable: () => ServiceUnavailable,
  SessionExpired: () => SessionExpired,
  StandardError: () => StandardError,
  SyncExtensionConnectorTimeoutError: () => SyncExtensionConnectorTimeoutError,
  SyncRuntimeMessageFailed: () => SyncRuntimeMessageFailed,
  SyncRuntimeMessageTimeoutError: () => SyncRuntimeMessageTimeoutError,
  Timeout: () => Timeout,
  UnexpectedScrapingResultError: () => UnexpectedScrapingResultError,
  UnimplementedWriteBackError: () => UnimplementedWriteBackError,
  UnprocessableEntity: () => UnprocessableEntity,
  UnsupportedWriteBackPayloadError: () => UnsupportedWriteBackPayloadError,
  VersionNotSupported: () => VersionNotSupported,
  WriteBackError: () => WriteBackError,
  WriteDiagnosisError: () => WriteDiagnosisError,
  WriteSpecialityError: () => WriteSpecialityError,
  WriteTargetProviderError: () => WriteTargetProviderError,
  WriteUpdatingProviderAlertError: () => WriteUpdatingProviderAlertError
});

// src/standard/errors/error-codes.ts
var ErrorCodes = /* @__PURE__ */ ((ErrorCodes2) => {
  ErrorCodes2[ErrorCodes2["INTERNAL_ERROR"] = 500] = "INTERNAL_ERROR";
  ErrorCodes2[ErrorCodes2["INVALID_INPUT"] = 400] = "INVALID_INPUT";
  ErrorCodes2[ErrorCodes2["NOT_FOUND"] = 404] = "NOT_FOUND";
  ErrorCodes2[ErrorCodes2["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
  ErrorCodes2[ErrorCodes2["TIMEOUT"] = 504] = "TIMEOUT";
  ErrorCodes2[ErrorCodes2["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
  ErrorCodes2[ErrorCodes2["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
  ErrorCodes2[ErrorCodes2["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
  return ErrorCodes2;
})(ErrorCodes || {});

// src/standard/errors/base-error.ts
var StandardError = class extends Error {
  constructor(message, code = 500 /* INTERNAL_ERROR */, properties = {}) {
    super(message);
    this.message = message;
    this.code = code;
    if (properties) {
      Object.keys(properties).forEach((key) => {
        this[key] = properties[key];
      });
    }
  }
  toJSON() {
    return Object.getOwnPropertyNames(this).filter((key) => key !== "properties").reduce((serialized, key) => ({
      ...serialized,
      [key]: this[key]
    }), {});
  }
};

// src/standard/errors/action-failed.ts
function errorMessage(action, originalError, ingrateErrorMessage) {
  if (ingrateErrorMessage) {
    return `Action ${action} has failed with error: ${originalError?.message}`;
  }
  return `Action ${action} has failed with error.`;
}
var ActionFailed = class extends StandardError {
  constructor(action, originalError, ingrateErrorMessage = false) {
    super(errorMessage(action, originalError, ingrateErrorMessage), 500 /* INTERNAL_ERROR */, {
      originalError
    });
  }
};

// src/standard/errors/invalid-input.ts
var InvalidInput = class extends StandardError {
  constructor(message, properties = {}) {
    super(message, 400 /* INVALID_INPUT */, { errorName: "InvalidInput", ...properties });
  }
};

// src/standard/errors/action-not-supported.ts
var ActionNotSupported = class extends InvalidInput {
  constructor(action) {
    super(`action ${action} is not supported!`, { errorName: "ActionNotSupported" });
  }
};

// src/standard/errors/appointment-errors.ts
var AppointmentAlreadyBooked = class extends StandardError {
  constructor(message, bookedAppointmentId = void 0, properties = {}) {
    super(message, 400 /* INVALID_INPUT */, {
      ...properties,
      errorName: "AppointmentAlreadyBooked"
    });
    this.bookedAppointmentId = bookedAppointmentId;
  }
};
var CreateAppointmentFailed = class extends StandardError {
  constructor(message, properties = {}) {
    super(message, 500 /* INTERNAL_ERROR */, {
      ...properties,
      errorName: "CreateAppointmentFailed"
    });
  }
};

// src/standard/errors/bad-gateway.ts
var BadGateway = class extends StandardError {
  constructor(message = "Bad Gateway", properties = {}) {
    super(message, 502 /* BAD_GATEWAY */, { errorName: "BadGateway", ...properties });
  }
};

// src/standard/errors/copy-to-clipboard-failed.ts
var CopyToClipboardFailed = class extends StandardError {
  constructor(error) {
    super(`${incoming_exports.IncomingMessages.COPY_TO_CLIPBOARD} has failed with error`, 500 /* INTERNAL_ERROR */, { error });
  }
};

// src/standard/errors/ehr-down.ts
var EhrDown = class extends StandardError {
  constructor(message = "Ehr is down", properties = {}) {
    super(message, 503 /* SERVICE_UNAVAILABLE */, { errorName: "EhrDown", ...properties });
  }
};

// src/standard/errors/internal-error.ts
var InternalError = class extends StandardError {
  constructor(message, properties = {}) {
    super(message, 500 /* INTERNAL_ERROR */, { errorName: "InternalError", ...properties });
  }
};

// src/standard/errors/not-found.ts
var NotFound = class extends StandardError {
  constructor(message, properties = {}) {
    super(message, 404 /* NOT_FOUND */, { errorName: "NotFound", ...properties });
  }
};

// src/standard/errors/location-not-found.ts
var LocationNotFound = class extends NotFound {
  constructor(properties) {
    super("Location not found", { ...properties, errorName: "LocationNotFound" });
    this.properties = properties;
  }
};

// src/standard/errors/organization-config-error.ts
var OrganizationConfigIsInvalid = class extends InvalidInput {
  constructor(configError) {
    super(`Organization config that was received is invalid - ${configError}`);
  }
};

// src/standard/errors/patient/patient-not-found.ts
var PatientNotFoundError = class extends NotFound {
  constructor(properties) {
    super("Patient not found", {
      ...properties,
      errorName: "PatientNotFoundError"
    });
  }
};

// src/standard/errors/patient-errors.ts
var CreatePatientFailed = class extends InternalError {
  constructor(properties) {
    super("Failed to create patient", { ...properties, errorName: "CreatePatientFailed" });
    this.properties = properties;
  }
};

// src/standard/errors/provider-not-found.ts
var ProviderNotFoundError = class extends NotFound {
  constructor(message, properties = {}) {
    super(message, {
      errorName: "ProviderNotFoundError",
      ...properties
    });
  }
};

// src/standard/errors/resource-not-found.ts
var ResourceNotFound = class extends NotFound {
  constructor(properties = {}) {
    super("Resource not found", { ...properties, errorName: "ResourceNotFound" });
    this.properties = properties;
  }
};

// src/standard/errors/service-unavailable.ts
var ServiceUnavailable = class extends StandardError {
  constructor(message, properties = {}) {
    super(message, 503 /* SERVICE_UNAVAILABLE */, {
      errorName: "ServiceUnavailable",
      ...properties
    });
  }
};

// src/standard/errors/session-expired.ts
var SessionExpired = class extends StandardError {
  constructor(message, properties = {}) {
    super(message, 503 /* SERVICE_UNAVAILABLE */, { errorName: "SessionExpired", ...properties });
  }
};

// src/standard/errors/sync-runtime-message-failed.ts
var SyncRuntimeMessageFailed = class extends StandardError {
  constructor(type, error) {
    super(`Sync message response from runtime failed`, 500 /* INTERNAL_ERROR */, { type, error });
  }
};

// src/standard/errors/sync-runtime-message-timeout-error.ts
var SyncRuntimeMessageTimeoutError = class extends StandardError {
  constructor(type, timeout2) {
    super(`Didn't get response from runtime message`, 500 /* INTERNAL_ERROR */, { type, timeout: timeout2 });
  }
};

// src/standard/errors/timeout.ts
var Timeout = class extends StandardError {
  constructor(message = "Timeout", properties = {}) {
    super(message, 504 /* TIMEOUT */, { errorName: "Timeout", ...properties });
  }
};

// src/standard/errors/sync-extension-connector-timeout-error.ts
var SyncExtensionConnectorTimeoutError = class extends StandardError {
  constructor(type, payload, timeout2, id = "", ackResponse) {
    super(`Didn't get response from extension/electron`, 500 /* INTERNAL_ERROR */, {
      type,
      payload,
      timeout: timeout2,
      id,
      ackResponse
    });
  }
};

// src/standard/errors/unexpected-scraping-result.ts
var UnexpectedScrapingResultError = class extends StandardError {
  constructor(message, properties) {
    super(message, 404 /* NOT_FOUND */, properties);
  }
};

// src/standard/errors/unprocessable-entity.ts
var UnprocessableEntity = class extends StandardError {
  constructor(message, properties = {}) {
    super(message, 422 /* UNPROCESSABLE_ENTITY */, {
      errorName: "UnprocessableEntity",
      ...properties
    });
  }
};

// src/standard/errors/write-back-error.ts
var WriteBackError = class extends InternalError {
  constructor(message, properties = {}) {
    super(message, { errorName: "WriteBackError", ...properties });
  }
};

// src/standard/errors/write-diagnosis-error.ts
var WriteDiagnosisError = class extends WriteBackError {
  constructor(message, properties = {}) {
    super(message, {
      errorName: "WriteDiagnosisError",
      ...properties
    });
  }
};

// src/standard/errors/write-speciality-error.ts
var WriteSpecialityError = class extends WriteBackError {
  constructor(message, properties = {}) {
    super(message, {
      errorName: "WriteSpecialityError",
      ...properties
    });
  }
};

// src/standard/errors/write-target-provider-error.ts
var WriteTargetProviderError = class extends WriteBackError {
  constructor(message, properties = {}) {
    super(message, {
      errorName: "WriteTargetProviderError",
      ...properties
    });
  }
};

// src/standard/errors/write-updating-provider-alert-error.ts
var WriteUpdatingProviderAlertError = class extends WriteBackError {
  constructor(message, properties = {}) {
    super(message, {
      errorName: "WriteUpdatingProviderAlertError",
      ...properties
    });
  }
};

// src/standard/errors/writebacks/unimplementedWriteBackError.ts
var UnimplementedWriteBackError = class extends WriteBackError {
  constructor(name, properties = {}) {
    super("Unimplemented WriteBack Error", { name, ...properties });
  }
};

// src/standard/errors/writebacks/unsupportedPayloadError.ts
var UnsupportedWriteBackPayloadError = class extends WriteBackError {
  constructor(name, payload) {
    super("Unsupported payload for event", { name, payload });
  }
};

// src/standard/errors/version-not-supported.ts
var VersionNotSupported = class extends StandardError {
  constructor(version, expectedVersion) {
    super("Version Not Supported", 500 /* INTERNAL_ERROR */, {
      errorName: "VersionNotSupported",
      version,
      expectedVersion
    });
  }
};

// src/infra/common/gql-client.ts
import gqlTag from "graphql-tag";
var RETRIES_ERRORS_WHITELIST = [
  "Failed to fetch",
  "ECONNRESET",
  "ENOTFOUND",
  "EHOSTUNREACH",
  "ECONNREFUSED",
  "socket hang up"
];
var RETRY_MUTATION_WHITELIST = /* @__PURE__ */ new Set(["initialLogin"]);
function isNetworkError(error) {
  return error && (RETRIES_ERRORS_WHITELIST.includes(error.message) || RETRIES_ERRORS_WHITELIST.find((errorCode) => error.code === errorCode || error.message.includes(errorCode)));
}
var MAX_RETRIES = 3;
var RETRY_DELAY = 250;
var NoAccessTokenError = class extends StandardError {
  constructor(context) {
    super("No Access Token Received", 401 /* UNAUTHORIZED */, context);
  }
};
var VimConnectGraphQLClient = class extends ApolloClient {
  constructor() {
    const httpLink = createHttpLink({ uri: "/api/graphql" });
    const authLink = setContext((_, { headers }) => {
      return {
        headers: {
          ...this.accessToken ? { authorization: this.accessToken } : void 0,
          ...this.deviceId ? { ["x-vim-device-id"]: this.deviceId } : void 0,
          ...this.isVimOsEnabled !== void 0 ? { ["x-vim-os-enabled"]: this.isVimOsEnabled } : void 0,
          ...headers
        }
      };
    });
    const errorLink = new ApolloLink((operation, forward) => {
      return forward(operation).map((data) => {
        if (data && data.errors) {
          const networkError = data.errors.find(isNetworkError);
          if (networkError) {
            throw new Error(networkError.message);
          }
        }
        return data;
      });
    });
    const retryLink = new RetryLink({
      delay: {
        initial: RETRY_DELAY,
        max: 2500,
        jitter: true
      },
      attempts: {
        max: MAX_RETRIES,
        retryIf: (error, operation) => {
          const isBaking = error?.bodyText?.toLowerCase().includes("baking");
          const operationDefinition = operation.query.definitions[0];
          const operationType = operationDefinition?.operation;
          const operationName = this.getOperationName(operationDefinition);
          const shouldRetry = operationType === "query" || RETRY_MUTATION_WHITELIST.has(operationName);
          return shouldRetry && (isBaking || isNetworkError(error));
        }
      }
    });
    super({
      link: ApolloLink.from([retryLink, authLink, errorLink, httpLink]),
      cache: new InMemoryCache({ resultCaching: true })
    });
  }
  setAccessToken(token) {
    this.accessToken = token;
  }
  setIsVimOsEnabled(isVimOsEnabled) {
    this.isVimOsEnabled = isVimOsEnabled;
  }
  setDeviceId(deviceId) {
    this.deviceId = deviceId;
  }
  getDeviceId() {
    return this.deviceId;
  }
  getOperationName(operationDefinition) {
    return operationDefinition.selectionSet?.selections?.[0]?.name?.value || operationDefinition.name?.value || "";
  }
  mutateAuthenticated(options) {
    if (!this.accessToken) {
      throw new NoAccessTokenError({
        options,
        accessToken: this.accessToken,
        deviceId: this.deviceId
      });
    }
    return this.mutate(options);
  }
  async mutate(options) {
    try {
      return await super.mutate(options);
    } catch (error) {
      if (error) {
        error.options = options;
      }
      throw error;
    }
  }
  async query(options) {
    try {
      return await super.query(options);
    } catch (error) {
      if (error) {
        error.options = options;
      }
      throw error;
    }
  }
  queryAuthenticated(options) {
    if (!this.accessToken) {
      throw new NoAccessTokenError({
        options,
        accessToken: this.accessToken,
        deviceId: this.deviceId
      });
    }
    return this.query(options);
  }
};
var gqlClient = new VimConnectGraphQLClient();

// src/infra/common/api/patient/get-vim-patient-id.ts
var GET_VIM_PATIENT_ID_QUERY = gql`
  query GetPatient($input: GetPatientInput!) {
    getPatient(input: $input) {
      vimPatientId
    }
  }
`;
var vimPatientIdLogger = logger.scope("getVimPatientId");
var getVimPatientId = async (input) => {
  const { patientId: id, firstName, lastName, dateOfBirth } = input;
  if (!id) {
    vimPatientIdLogger.warning("Cannot query vim patient id without patient id", { input });
    return;
  }
  try {
    const response = await gqlClient.queryAuthenticated({
      query: GET_VIM_PATIENT_ID_QUERY,
      variables: { input: { id, firstName, lastName, dateOfBirth } },
      context: { uri: "/runtime/api/graphql" }
    });
    const vimPatientId = response?.data?.getPatient?.vimPatientId;
    vimPatientIdLogger.info("fetched vimPatientId", { patientId: id, vimPatientId });
    return vimPatientId;
  } catch (error) {
    const sanitizedError = sanitizeError(error);
    if (error instanceof NoAccessTokenError) {
      vimPatientIdLogger.info("getVimPatientId called when user not logged in", {
        patientId: id,
        error: sanitizedError
      });
    } else {
      vimPatientIdLogger.error("Failed to fetch to vimPatientId", {
        patientId: id,
        error: sanitizedError
      });
    }
    return void 0;
  }
};
var sanitizeError = (error) => {
  if (!error)
    return error;
  const sanitized = { ...error };
  if (sanitized.options?.variables?.input) {
    const { id } = sanitized.options.variables.input;
    sanitized.options.variables.input = { id };
  }
  return sanitized;
};

// src/common/index.ts
var common_exports = {};
__export(common_exports, {
  formatDate: () => formatDate,
  getActivePayerSource: () => getActivePayerSource,
  getActiveSource: () => getActiveSource,
  getDiffFromDateInDays: () => getDiffFromDateInDays,
  isDevelopmentMode: () => isDevelopmentMode,
  isDirectSource: () => isDirectSource,
  isHtmlOrXML: () => isHtmlOrXML,
  isProvider: () => isProvider,
  timeoutAfter: () => timeoutAfter
});

// src/common/utils.ts
import dayjs from "dayjs";
import { withTimeout } from "@vim/promise";
var timeoutAfter = async (asyncFunc, timeoutInMs, shouldThrow) => {
  try {
    const asyncFunctionWithTimeout = withTimeout(asyncFunc, timeoutInMs);
    return await asyncFunctionWithTimeout();
  } catch (error) {
    if (shouldThrow) {
      throw error;
    }
  }
};
var isHtmlOrXML = (str) => {
  return /(<([^>]+)>)/i.test(str);
};
var formatDate = (date, format) => dayjs(date).format(format);
var getDiffFromDateInDays = (date) => dayjs().diff(date, "days");

// src/common/get-source.ts
import { ProductSource, ProviderSource } from "@getvim-core-apps/organizations";
var getActiveSource = (patient, sources) => {
  if (!sources)
    return;
  const safeSources = unifySources(sources);
  if (safeSources.includes(ProductSource.Direct))
    return ProductSource.Direct;
  const payerSource = safeSources?.find((source) => source === patient?.insurance?.insurer?.toString());
  if (payerSource)
    return payerSource;
};
var getActivePayerSource = (patient, sources) => {
  if (!sources)
    return;
  const safeSources = unifySources(sources);
  const payerSource = safeSources?.find((source) => source === patient?.insurance?.insurer?.toString());
  if (payerSource)
    return payerSource;
};
var isDirectSource = (sources) => {
  if (!sources)
    return false;
  const safeSources = unifySources(sources);
  return safeSources.includes(ProductSource.Direct);
};
var isProvider = (contentSources) => {
  if (!contentSources)
    return false;
  return contentSources.some((source) => Object.values(ProviderSource).includes(source));
};
var unifySources = (sources) => {
  return Array.isArray(sources) ? sources : sources.split(",");
};

// src/common/isDevelopmentMode.ts
function isDevelopmentMode(origin) {
  const developmentUrls = [
    "localhost",
    "10.211.55.2",
    ".sish.devim.io",
    ".sish.dev.getvim.com",
    ".localhost.getvim.com",
    "your_mac_ip:"
  ];
  return developmentUrls.some((urlPart) => origin.includes(urlPart));
}

// src/runtime-contract/outgoing/payloads-transformers/transformers/utils/set-vim-patient-id.ts
var TIMEOUT_AFTER = 3e3;
var CACHE_TTL = 15 * 60;
var vimPatientIdCache = new NodeCache({ stdTTL: CACHE_TTL });
var getVimPatientId2 = async (patient, logger10, options) => {
  try {
    const { shouldUseTimeoutOnTransformers } = options ?? {};
    const { demographics, patientId } = patient;
    const { firstName, lastName, dateOfBirth } = demographics ?? {};
    if (!firstName || !lastName || !dateOfBirth) {
      logger10.info("Received a patient with missing demographics fields in setVimPatientId", {
        demographics
      });
      return;
    }
    let vimPatientId = vimPatientIdCache.get(patientId);
    logger10.info("Current cached VimPatientId", {
      noPHI: true,
      patientId,
      cachedVimPatientId: vimPatientId
    });
    if (!vimPatientId) {
      vimPatientId = shouldUseTimeoutOnTransformers ? await timeoutAfter(() => getVimPatientId({ patientId, firstName, lastName, dateOfBirth }), TIMEOUT_AFTER, true) : await getVimPatientId({ patientId, firstName, lastName, dateOfBirth });
      vimPatientIdCache.set(patientId, vimPatientId);
    }
    return vimPatientId;
  } catch (error) {
    logger10.error("Failed to set vimPatientId in patient payload transformer", {
      error,
      patient
    });
  }
};

// src/runtime-contract/outgoing/payloads-transformers/transformers/utils/get-content-supplier-patient-identifier.ts
import { isEmpty, mapKeys, omit, omitBy } from "lodash-es";
import NodeCache2 from "node-cache";

// src/infra/common/api/patient/getContentSupplierIdsSources.ts
import gql2 from "graphql-tag";
import { logger as logger2 } from "@getvim/vim-connect-logger";
var contentSupplierIdentifiersLogger = logger2.scope("getContentSupplierIdentifiers query");

// src/runtime-contract/outgoing/payloads-transformers/transformers/utils/get-content-supplier-patient-identifier.ts
var CACHE_TTL2 = 15 * 60;
var contentSupplierPatientIdentifiersCache = new NodeCache2({ stdTTL: CACHE_TTL2 });

// src/standard/actions-transformers/get-patient.ts
var transformerActionLogger = logger3.scope("GET_PATIENT action transformer");
var GET_PATIENT = async (actionResponse) => {
  const vimPatientId = await getVimPatientId2(actionResponse, transformerActionLogger);
  return { ...actionResponse, vimPatientId };
};

// src/standard/events/index.ts
var events_exports = {};

// src/standard/entities/index.ts
var entities_exports = {};
__export(entities_exports, {
  Gender: () => Gender,
  OrderType: () => OrderType,
  ProviderType: () => ProviderType,
  ReferralPriority: () => ReferralPriority,
  ReferralStatus: () => ReferralStatus,
  ReleaseOfInformation: () => ReleaseOfInformation,
  UIElements: () => ui_elements_exports
});

// src/standard/entities/common/gender.ts
var Gender = /* @__PURE__ */ ((Gender2) => {
  Gender2["male"] = "male";
  Gender2["female"] = "female";
  return Gender2;
})(Gender || {});

// src/standard/entities/patient/index.ts
var ReleaseOfInformation = /* @__PURE__ */ ((ReleaseOfInformation2) => {
  ReleaseOfInformation2["Y"] = "Yes allow to release";
  ReleaseOfInformation2["M"] = "modified release (partial release)";
  ReleaseOfInformation2["N"] = "no release";
  ReleaseOfInformation2["ANSI"] = "ansi 5010";
  ReleaseOfInformation2["UNKNOWN"] = "option not mapped";
  return ReleaseOfInformation2;
})(ReleaseOfInformation || {});

// src/standard/entities/provider/index.ts
var ProviderType = /* @__PURE__ */ ((ProviderType2) => {
  ProviderType2["ORGANIZATION"] = "ORGANIZATION";
  ProviderType2["UNKNOWN"] = "UNKNOWN";
  return ProviderType2;
})(ProviderType || {});

// src/standard/entities/referral/index.ts
import { ReferralStatus } from "@getvim/provider-types";
var ReferralPriority = /* @__PURE__ */ ((ReferralPriority2) => {
  ReferralPriority2["ROUTINE"] = "ROUTINE";
  ReferralPriority2["URGENT"] = "URGENT";
  ReferralPriority2["STAT"] = "STAT";
  return ReferralPriority2;
})(ReferralPriority || {});

// src/standard/entities/order/index.ts
var OrderType = /* @__PURE__ */ ((OrderType2) => {
  OrderType2["LAB"] = "LAB";
  OrderType2["DI"] = "DI";
  OrderType2["PROCEDURE"] = "PROCEDURE";
  OrderType2["RX"] = "RX";
  OrderType2["REFERRAL"] = "REFERRAL";
  return OrderType2;
})(OrderType || {});

// src/standard/entities/ui-elements/index.ts
var ui_elements_exports = {};
__export(ui_elements_exports, {
  ExpandingType: () => ExpandingType,
  ModifyReason: () => ModifyReason,
  UISectionNames: () => UISectionNames,
  VimConnectUIUtilsWidget: () => VimConnectUIUtilsWidget
});

// src/standard/entities/ui-elements/ui-sections.ts
var UISectionNames = /* @__PURE__ */ ((UISectionNames2) => {
  UISectionNames2["referralSelectProvider"] = "referralSelectProvider";
  UISectionNames2["labsSelectProvider"] = "labsSelectProvider";
  UISectionNames2["diSelectProvider"] = "diSelectProvider";
  return UISectionNames2;
})(UISectionNames || {});

// src/standard/entities/ui-elements/widget.ts
var ModifyReason = /* @__PURE__ */ ((ModifyReason2) => {
  ModifyReason2["Response"] = "response";
  ModifyReason2["PatientEligible"] = "patientEligible";
  return ModifyReason2;
})(ModifyReason || {});
var VimConnectUIUtilsWidget = /* @__PURE__ */ ((VimConnectUIUtilsWidget2) => {
  VimConnectUIUtilsWidget2["Overlay"] = "overlay";
  VimConnectUIUtilsWidget2["WriteBackLoading"] = "writeBackLoading";
  return VimConnectUIUtilsWidget2;
})(VimConnectUIUtilsWidget || {});

// src/standard/entities/ui-elements/expanding-type.ts
var ExpandingType = /* @__PURE__ */ ((ExpandingType2) => {
  ExpandingType2["AUTOMATIC"] = "automatic";
  ExpandingType2["VIM_HUB_MANUAL"] = "manual";
  ExpandingType2["VIM_APP_MANUAL"] = "vim-app-manual";
  ExpandingType2["VIM_NOTIFICATION_MANUAL"] = "vim-notification-manual";
  return ExpandingType2;
})(ExpandingType || {});

// src/standard/connectors/index.ts
var connectors_exports = {};
__export(connectors_exports, {
  Common: () => common_exports2,
  Web: () => web_exports
});

// src/standard/connectors/web/index.ts
var web_exports = {};
__export(web_exports, {
  ActionType: () => ActionType,
  Enums: () => enums_exports,
  WebConnectorMessageTypes: () => WebConnectorMessageTypes
});

// src/standard/connectors/web/message-types/invokeFunctionWithCachedParams.ts
var ActionType = /* @__PURE__ */ ((ActionType2) => {
  ActionType2["GET_ACTION_RESULT"] = "getActionResult";
  ActionType2["GET_PATH_RESULT"] = "getPathResult";
  ActionType2["INVOKE_LAST_ITERATION_RESULT"] = "invokeLastIterationResult";
  return ActionType2;
})(ActionType || {});

// src/standard/connectors/web/message-types/index.ts
var WebConnectorMessageTypes = /* @__PURE__ */ ((WebConnectorMessageTypes2) => {
  WebConnectorMessageTypes2["getActiveTab"] = "getActiveTab";
  WebConnectorMessageTypes2["extensionVersion"] = "extensionVersion";
  WebConnectorMessageTypes2["getLastLoginRequest"] = "getLastLoginRequest";
  WebConnectorMessageTypes2["sendUserDetails"] = "sendUserDetails";
  WebConnectorMessageTypes2["sendPopupDetails"] = "sendPopupDetails";
  WebConnectorMessageTypes2["addEventListener"] = "addEventListener";
  WebConnectorMessageTypes2["observeMutations"] = "observeMutations";
  WebConnectorMessageTypes2["disconnectObserver"] = "disconnectObserver";
  WebConnectorMessageTypes2["fetchData"] = "fetchData";
  WebConnectorMessageTypes2["callJQueryAjax"] = "callJQueryAjax";
  WebConnectorMessageTypes2["insertElement"] = "insertElement";
  WebConnectorMessageTypes2["getAttribute"] = "getAttribute";
  WebConnectorMessageTypes2["invokeFunction"] = "invokeFunction";
  WebConnectorMessageTypes2["jqueryInvokeFunction"] = "jqueryInvokeFunction";
  WebConnectorMessageTypes2["scrape"] = "scrape";
  WebConnectorMessageTypes2["scrapeFirst"] = "scrapeFirst";
  WebConnectorMessageTypes2["scrapeInnerHtml"] = "scrapeInnerHtml";
  WebConnectorMessageTypes2["scrapeParent"] = "scrapeParent";
  WebConnectorMessageTypes2["updateElement"] = "updateElement";
  WebConnectorMessageTypes2["changeValue"] = "changeValue";
  WebConnectorMessageTypes2["dispatchEvent"] = "dispatchEvent";
  WebConnectorMessageTypes2["dispatchMouseEvent"] = "dispatchMouseEvent";
  WebConnectorMessageTypes2["backboneGetModel"] = "backboneGetModel";
  WebConnectorMessageTypes2["backboneInvoke"] = "backboneInvoke";
  WebConnectorMessageTypes2["backboneDoesFunctionExists"] = "backboneDoesFunctionExists";
  WebConnectorMessageTypes2["angularGetScope"] = "angularGetScope";
  WebConnectorMessageTypes2["angularSetScope"] = "angularSetScope";
  WebConnectorMessageTypes2["angularGetService"] = "angularGetService";
  WebConnectorMessageTypes2["angularInvokeOnScope"] = "angularInvokeOnScope";
  WebConnectorMessageTypes2["angularInvokeOnService"] = "angularInvokeOnService";
  WebConnectorMessageTypes2["addWebRequestListener"] = "addWebRequestListener";
  WebConnectorMessageTypes2["chromeCreateTab"] = "chromeCreateTab";
  WebConnectorMessageTypes2["chromeSetBrowserAction"] = "chromeSetBrowserAction";
  WebConnectorMessageTypes2["getCurrentUrl"] = "getCurrentUrl";
  WebConnectorMessageTypes2["setCurrentUrl"] = "setCurrentUrl";
  WebConnectorMessageTypes2["addOpenedTabsMessageListener"] = "addOpenedTabsMessageListener";
  WebConnectorMessageTypes2["eventBusInitialized"] = "eventBusInitialized";
  WebConnectorMessageTypes2["webPageUnstable"] = "webPageUnstable";
  WebConnectorMessageTypes2["addAjaxRequestListener"] = "addAjaxRequestListener";
  WebConnectorMessageTypes2["decryptECWStringByKey"] = "decryptECWStringByKey";
  WebConnectorMessageTypes2["getLocalStorageKey"] = "getLocalStorageKey";
  WebConnectorMessageTypes2["setLocalStorageKey"] = "setLocalStorageKey";
  WebConnectorMessageTypes2["removeLocalStorageKey"] = "removeLocalStorageKey";
  WebConnectorMessageTypes2["overrideGlobalFunction"] = "overrideGlobalFunction";
  WebConnectorMessageTypes2["getInstallationType"] = "getInstallationType";
  WebConnectorMessageTypes2["invokeFunctionWithCachedParams"] = "invokeFunctionWithCachedParams";
  return WebConnectorMessageTypes2;
})(WebConnectorMessageTypes || {});

// src/standard/connectors/web/enums/index.ts
var enums_exports = {};
__export(enums_exports, {
  AllowedEvents: () => AllowedEvents,
  AllowedFunctions: () => AllowedFunctions,
  OverrideGlobalFunctionTypes: () => OverrideGlobalFunctionTypes
});

// src/standard/connectors/web/enums/allowed-events.ts
var AllowedEvents = /* @__PURE__ */ ((AllowedEvents2) => {
  AllowedEvents2["change"] = "change";
  AllowedEvents2["keydown"] = "keydown";
  AllowedEvents2["keyup"] = "keyup";
  AllowedEvents2["click"] = "click";
  AllowedEvents2["mousedown"] = "mousedown";
  AllowedEvents2["mouseover"] = "mouseover";
  AllowedEvents2["pointerover"] = "pointerover";
  AllowedEvents2["blur"] = "blur";
  AllowedEvents2["input"] = "input";
  return AllowedEvents2;
})(AllowedEvents || {});

// src/standard/connectors/web/enums/allowed-functions.ts
var AllowedFunctions = /* @__PURE__ */ ((AllowedFunctions2) => {
  AllowedFunctions2["blur"] = "blur";
  AllowedFunctions2["click"] = "click";
  AllowedFunctions2["closest"] = "closest";
  AllowedFunctions2["focus"] = "focus";
  AllowedFunctions2["getAttribute"] = "getAttribute";
  AllowedFunctions2["setAttribute"] = "setAttribute";
  AllowedFunctions2["makeURL"] = "makeURL";
  AllowedFunctions2["removeAttribute"] = "removeAttribute";
  AllowedFunctions2["urlGet"] = "urlGet";
  AllowedFunctions2["urlPost"] = "urlPost";
  AllowedFunctions2["getMappedVisitTypesToResource"] = "getMappedVisitTypesToResource";
  AllowedFunctions2["MD5"] = "MD5";
  AllowedFunctions2["hex_sha1"] = "hex_sha1";
  AllowedFunctions2["getBoundingClientRect"] = "getBoundingClientRect";
  AllowedFunctions2["close"] = "close";
  AllowedFunctions2["refreshDashboard"] = "refreshDashboard";
  AllowedFunctions2["reloadOVItemContext"] = "reloadOVItemContext";
  return AllowedFunctions2;
})(AllowedFunctions || {});

// src/standard/connectors/web/enums/override-global-function.ts
var OverrideGlobalFunctionTypes = /* @__PURE__ */ ((OverrideGlobalFunctionTypes2) => {
  OverrideGlobalFunctionTypes2["RETURN_ITSELF"] = "return_itself";
  return OverrideGlobalFunctionTypes2;
})(OverrideGlobalFunctionTypes || {});

// src/standard/connectors/common/index.ts
var common_exports2 = {};
__export(common_exports2, {
  CommonConnectorMessageTypes: () => CommonConnectorMessageTypes
});

// src/standard/connectors/common/message-types/index.ts
var CommonConnectorMessageTypes = /* @__PURE__ */ ((CommonConnectorMessageTypes2) => {
  CommonConnectorMessageTypes2["removeListener"] = "removeListener";
  CommonConnectorMessageTypes2["sendExtensionLog"] = "sendExtensionLog";
  CommonConnectorMessageTypes2["chromeStorageGet"] = "chromeStorageGet";
  CommonConnectorMessageTypes2["chromeStorageSet"] = "chromeStorageSet";
  CommonConnectorMessageTypes2["chromeStorageRemove"] = "chromeStorageRemove";
  CommonConnectorMessageTypes2["injectWidget"] = "injectWidget";
  CommonConnectorMessageTypes2["removeWidget"] = "removeWidget";
  CommonConnectorMessageTypes2["sendDataToWidget"] = "sendDataToWidget";
  CommonConnectorMessageTypes2["modifyWidget"] = "modifyWidget";
  CommonConnectorMessageTypes2["listenToDataFromWidgets"] = "listenToDataFromWidgets";
  return CommonConnectorMessageTypes2;
})(CommonConnectorMessageTypes || {});

// src/standard/secrets/index.ts
var secrets_exports = {};
__export(secrets_exports, {
  Notes: () => Notes
});
var Notes = /* @__PURE__ */ ((Notes2) => {
  Notes2["SQL_SECRETS_NOTE_NAME"] = "sql secrets";
  return Notes2;
})(Notes || {});

// src/standard/write-backs/index.ts
var write_backs_exports = {};
__export(write_backs_exports, {
  ActionStatus: () => ActionStatus,
  SelectAction: () => SelectAction,
  formatProvider: () => formatProvider
});

// src/standard/write-backs/updateReferral.ts
var SelectAction = /* @__PURE__ */ ((SelectAction2) => {
  SelectAction2["WRITEBACK"] = "writeback";
  SelectAction2["COPY_TO_CLIPBOARD"] = "copy_to_clipboard";
  return SelectAction2;
})(SelectAction || {});
var ActionStatus = /* @__PURE__ */ ((ActionStatus2) => {
  ActionStatus2["SUCCESS"] = "success";
  ActionStatus2["FAILED"] = "failed";
  return ActionStatus2;
})(ActionStatus || {});

// src/standard/write-backs/formatProvider.ts
var formatProvider = (provider, withNewLines = false) => {
  const divider = withNewLines ? "\n" : ", ";
  const name = provider.demographics?.lastName ? `${provider.demographics.lastName}, ${provider.demographics.firstName}` : void 0;
  const providerInfo = `Provider Result:${withNewLines ? "\n" : " "}${name}, NPI: ${provider.npi}`;
  const specialities = `Specialties: ${provider.specialty?.map((specialty) => specialty.description)?.join(", ")}`;
  const organization = provider.organizations?.[0] ?? provider.organization ?? {};
  const { address, contact_info: contactInfo } = organization;
  const fullAddress = address?.fullAddress || getFullAddress(address);
  const providerOfficeName = organization.name ? `Office Name: ${organization.name}` : void 0;
  const providerFullAddress = fullAddress ? `Address: ${fullAddress}` : "No address available";
  const providerAddress = providerOfficeName ? `${providerOfficeName}${divider}${providerFullAddress}` : providerFullAddress;
  const { mobilePhoneNumber, faxNumber } = contactInfo ?? {};
  const providerContactInfo = mobilePhoneNumber ? `Phone: ${mobilePhoneNumber}${divider}Fax: ${faxNumber}` : "No phone number available";
  return [providerInfo, specialities, providerAddress, providerContactInfo].map((str) => str.replace(new RegExp("undefined", "g"), "---")).join(divider);
};
var getFullAddress = ({ address1, address2, city, state, zipCode } = {}) => {
  return [address1, address2, city, state, zipCode].filter((item) => !!item).join(", ");
};

// src/login/index.ts
var login_exports = {};
__export(login_exports, {
  ContactDetailType: () => ContactDetailType,
  INTERNAL_SERVER_ERROR_MESSAGE: () => INTERNAL_SERVER_ERROR_MESSAGE,
  LoginMethodType: () => LoginMethodType
});
var LoginMethodType = /* @__PURE__ */ ((LoginMethodType3) => {
  LoginMethodType3["SINGLE_SIGN_ON"] = "SINGLE_SIGN_ON";
  LoginMethodType3["INTERACTIVE_SSO"] = "INTERACTIVE_SSO";
  LoginMethodType3["CREDENTIALS"] = "CREDENTIALS";
  LoginMethodType3["SEAMLESS_LOGIN"] = "SEAMLESS_LOGIN";
  LoginMethodType3["ID_TOKEN"] = "ID_TOKEN";
  LoginMethodType3["SILENT_LOGIN"] = "SILENT_LOGIN";
  LoginMethodType3["ACCESS_TOKEN"] = "ACCESS_TOKEN";
  LoginMethodType3["REFRESH_TOKEN"] = "REFRESH_TOKEN";
  LoginMethodType3["OTP"] = "OTP";
  return LoginMethodType3;
})(LoginMethodType || {});
var ContactDetailType = /* @__PURE__ */ ((ContactDetailType2) => {
  ContactDetailType2["Email"] = "email";
  ContactDetailType2["Phone"] = "phone";
  return ContactDetailType2;
})(ContactDetailType || {});
var INTERNAL_SERVER_ERROR_MESSAGE = "Internal server error on initial login";

// src/adapters/index.ts
var adapters_exports = {};

// src/widget-events/index.ts
var widget_events_exports = {};
__export(widget_events_exports, {
  SelectProviderButtonSource: () => SelectProviderButtonSource
});

// src/widget-events/populate-order-assist.ts
var SelectProviderButtonSource = /* @__PURE__ */ ((SelectProviderButtonSource2) => {
  SelectProviderButtonSource2["REFERRAL"] = "referral";
  SelectProviderButtonSource2["DI"] = "di";
  SelectProviderButtonSource2["LAB"] = "lab";
  return SelectProviderButtonSource2;
})(SelectProviderButtonSource || {});

// src/infra/index.ts
var infra_exports = {};
__export(infra_exports, {
  Apps: () => apps_exports,
  Common: () => common_exports3,
  MessageChannel: () => messageChannel_exports
});

// src/infra/apps/index.ts
var apps_exports = {};
__export(apps_exports, {
  Product: () => Product,
  VimConnectWidgetIncomingEventName: () => VimConnectWidgetIncomingEventName,
  VimConnectWidgetOutgoingEventName: () => VimConnectWidgetOutgoingEventName,
  WidgetPayloadType: () => WidgetPayloadType,
  calculateWidgetUrl: () => calculateWidgetUrl,
  getWidgetsConfig: () => getWidgetsConfig,
  isProvidersEquals: () => isProvidersEquals,
  searchProviders: () => searchProviders
});

// src/infra/apps/utils/getWidgetsConfig.ts
import axios from "axios";
import { logger as logger4 } from "@getvim/vim-connect-logger";
import { retry } from "@vim/promise";
var scopedLogger = logger4.scope("getWidgetConfig");
var axiosInstance = axios.create({ timeout: 3e4 });
async function getWidgetsConfig() {
  try {
    let response;
    await retry(async (retryNumber) => {
      scopedLogger.info("Trying to get widgets config", {
        noPHI: true,
        retryNumber
      });
      try {
        response = await axiosInstance.get("/api/widgetsConfig");
      } catch (error) {
        scopedLogger.warning("Failed to get widgets config", {
          error,
          noPHI: true
        });
        throw error;
      }
      scopedLogger.info("get widgets config completed", { noPHI: true });
    }, { retries: 5 });
    return response.data;
  } catch (error) {
    scopedLogger.error(`Could not fetch client config!`, { error });
    throw error;
  }
}

// src/infra/apps/utils/is-providers-equals.ts
var isProvidersEquals = (firstProvider, secondProvider) => {
  return JSON.stringify(firstProvider) === JSON.stringify(secondProvider);
};

// src/infra/apps/utils/widgetBaseUrl.ts
import { logger as logger5 } from "@getvim/vim-connect-logger";
async function calculateWidgetUrl(widgetName, envToUrlMap, overrideWidgetsConfig) {
  const overrideWidgetEnv = overrideWidgetsConfig?.[widgetName]?.widgetEnv;
  const urlByOverrideWidgetEnv = overrideWidgetEnv && envToUrlMap?.[overrideWidgetEnv];
  if (urlByOverrideWidgetEnv) {
    logger5.scope("calculateWidgetUrl").info(`Widget "${widgetName}" calculated URL is [${urlByOverrideWidgetEnv}] since an override widget config was provided`, { widgetEnv: overrideWidgetEnv });
    return urlByOverrideWidgetEnv;
  }
  const config = await getWidgetsConfig();
  if (!config?.widgetsDefaultEnv) {
    throw new Error(`client config has no parameter widgetsDefaultEnv`);
  }
  const overrideUrlConfig = config.widgetsUrl?.[widgetName];
  if (overrideUrlConfig) {
    logger5.scope("calculateWidgetUrl").info(`Widget "${widgetName}" calculated URL is [${overrideUrlConfig}] since an override was provided`, config);
    return overrideUrlConfig;
  }
  const urlByDefaultEnv = envToUrlMap[config.widgetsDefaultEnv];
  if (urlByDefaultEnv) {
    logger5.scope("calculateWidgetUrl").info(`Widget "${widgetName}" calculated URL is [${urlByDefaultEnv}] due to default widget env "${config?.widgetsDefaultEnv}"`, config);
    return urlByDefaultEnv;
  }
  throw new Error(`Could not find matching URL for widget [${widgetName}]! client configuration: ${JSON.stringify(config)}, envToUrlMap: ${JSON.stringify(envToUrlMap)}`);
}

// src/infra/apps/utils/searchProviders.ts
function searchProviders(allProviders, limit, offset, searchTerm) {
  if (!searchTerm) {
    return allProviders.slice(offset, offset + limit);
  }
  const lowerSearchTerm = searchTerm.toLowerCase().trim();
  const allResults = allProviders.filter((provider) => {
    const firstName = provider.demographics.firstName.toLowerCase();
    const lastName = provider.demographics.lastName.toLowerCase();
    const fullName = `{${firstName} ${lastName}}`;
    return fullName.startsWith(lowerSearchTerm) || lastName.startsWith(lowerSearchTerm) || firstName.startsWith(lowerSearchTerm);
  });
  return allResults.slice(offset, offset + limit);
}

// src/infra/apps/types/events.ts
var VimConnectWidgetOutgoingEventName = /* @__PURE__ */ ((VimConnectWidgetOutgoingEventName2) => {
  VimConnectWidgetOutgoingEventName2["GetVimPatientId"] = "GetVimPatientId";
  VimConnectWidgetOutgoingEventName2["TrackAnalyticsData"] = "TrackAnalyticsData";
  return VimConnectWidgetOutgoingEventName2;
})(VimConnectWidgetOutgoingEventName || {});
var VimConnectWidgetIncomingEventName = /* @__PURE__ */ ((VimConnectWidgetIncomingEventName2) => {
  VimConnectWidgetIncomingEventName2["GetVimPatientIdResult"] = "GetVimPatientIdResult";
  VimConnectWidgetIncomingEventName2["AnalyticsApplicationProperties"] = "AnalyticsApplicationProperties";
  return VimConnectWidgetIncomingEventName2;
})(VimConnectWidgetIncomingEventName || {});

// src/infra/apps/types/payload.ts
var WidgetPayloadType = /* @__PURE__ */ ((WidgetPayloadType2) => {
  WidgetPayloadType2["LOGIN_FAILURE"] = "vim-connect-login-failure";
  WidgetPayloadType2["ACCESS_TOKEN"] = "vim-connect-login-access-token";
  WidgetPayloadType2["CLOSE"] = "vim-connect-login-close";
  WidgetPayloadType2["WIDGET_READY"] = "vim-connect-widget-ready";
  WidgetPayloadType2["MODIFY_WIDGET"] = "vim-connect-modify-widget";
  WidgetPayloadType2["SEAMLESS_LOGIN_APPROVED"] = "vim-connect-seamless-login-approved";
  WidgetPayloadType2["SEAMLESS_LOGIN_FAILED"] = "vim-connect-seamless-login-failed";
  WidgetPayloadType2["USER_LOGIN_ATTEMPT"] = "vim-connect-user-login-attempt";
  return WidgetPayloadType2;
})(WidgetPayloadType || {});

// src/infra/apps/types/product.ts
var Product = /* @__PURE__ */ ((Product2) => {
  Product2["DiagnosisGaps"] = "diagnosis-gaps";
  Product2["Eligibility"] = "eligibility";
  Product2["OrderAssist"] = "order-assist";
  Product2["PatientHealthHistory"] = "patient-health-history";
  Product2["PriorAuthCheck"] = "prior-auth-check";
  Product2["QualityGaps"] = "quality-gaps";
  Product2["ReferralGuidance"] = "referral-guidance";
  Product2["OptumReferralUtility"] = "optum-referral-utility";
  Product2["OptimalCare"] = "optimal-care";
  Product2["Scheduling"] = "scheduling";
  Product2["OptumDataCore"] = "optum-data-core";
  Product2["OptumPro"] = "optum-pro";
  Product2["OptumDataCoreDashboard"] = "optum-data-core-dashboard";
  Product2["MockCanvasApp"] = "mock-canvas-app";
  Product2["FhirSimulator"] = "fhir-simulator";
  Product2["CDE"] = "clinical-data-exchange";
  Product2["Kahun"] = "kahun";
  Product2["PriviaInsights"] = "privia-insights";
  Product2["RxAssist"] = "rx-assist";
  return Product2;
})(Product || {});

// src/infra/common/index.ts
var common_exports3 = {};
__export(common_exports3, {
  Api: () => api_exports,
  Consts: () => consts_exports,
  LTSSupport: () => lts_support_exports,
  Poller: () => poller_exports,
  Types: () => types_exports,
  Utils: () => utils_exports
});

// src/infra/common/types/index.ts
var types_exports = {};
__export(types_exports, {
  HorizontalDirection: () => HorizontalDirection,
  HorizontalHubPosition: () => HorizontalHubPosition,
  LoginEvent: () => LoginEvent2,
  LoginMethodType: () => LoginMethodType2,
  LoginResultType: () => LoginResultType,
  SMARTApp: () => SMARTApp,
  StorageKnownKey: () => StorageKnownKey,
  VerticalDirection: () => VerticalDirection,
  VerticalHubPosition: () => VerticalHubPosition
});

// src/infra/common/types/hubPosition.ts
var VerticalHubPosition = /* @__PURE__ */ ((VerticalHubPosition2) => {
  VerticalHubPosition2["Low"] = "Low";
  VerticalHubPosition2["Low_Middle"] = "Low_Middle";
  VerticalHubPosition2["Middle"] = "Middle";
  VerticalHubPosition2["High_Middle"] = "High_Middle";
  VerticalHubPosition2["High"] = "High";
  return VerticalHubPosition2;
})(VerticalHubPosition || {});
var VerticalDirection = /* @__PURE__ */ ((VerticalDirection2) => {
  VerticalDirection2["Down"] = "Down";
  VerticalDirection2["Up"] = "Up";
  return VerticalDirection2;
})(VerticalDirection || {});
var HorizontalHubPosition = /* @__PURE__ */ ((HorizontalHubPosition2) => {
  HorizontalHubPosition2["Right"] = "Right";
  HorizontalHubPosition2["Left"] = "Left";
  return HorizontalHubPosition2;
})(HorizontalHubPosition || {});
var HorizontalDirection = /* @__PURE__ */ ((HorizontalDirection2) => {
  HorizontalDirection2["Right"] = "Right";
  HorizontalDirection2["Left"] = "Left";
  return HorizontalDirection2;
})(HorizontalDirection || {});

// src/infra/common/types/storage.ts
var StorageKnownKey = /* @__PURE__ */ ((StorageKnownKey2) => {
  StorageKnownKey2["DEVICE_ID"] = "device_id";
  StorageKnownKey2["HOSTNAME"] = "hostname";
  StorageKnownKey2["USERNAME"] = "username";
  StorageKnownKey2["SALT"] = "salt";
  StorageKnownKey2["VIM_TOKENS"] = "vimTokens";
  StorageKnownKey2["OVERRIDE_ORGANIZATION"] = "overrideOrgName";
  StorageKnownKey2["OVERRIDE_WIDGETS_CONFIGURATION"] = "overrideWidgetsConfiguration";
  StorageKnownKey2["MSI_VERSION"] = "MSI_VERSION";
  StorageKnownKey2["KEY"] = "KEY";
  StorageKnownKey2["EHR"] = "EHR";
  StorageKnownKey2["EHR_URL"] = "EHR_URL";
  StorageKnownKey2["OVERRIDE_ENV_CONFIG"] = "overrideEnvironmentConfig";
  StorageKnownKey2["OVERRIDE_ORG_KEY"] = "overrideOrgKey";
  StorageKnownKey2["OVERRIDE_PROCESS"] = "overrideProcess";
  StorageKnownKey2["OVERRIDE_EHR_INSTANCE_URL"] = "overrideEhrInstanceUrl";
  StorageKnownKey2["NOTIFICATIONS_DETAILS"] = "notificationsDetails";
  StorageKnownKey2["VIM_CONNECT_UI"] = "vim-connect-ui";
  StorageKnownKey2["TECHNICAL_OPTIONS"] = "technicalOptions";
  StorageKnownKey2["LAST_AUTOMATIC_REFRESH_TIME"] = "lastAutomaticRefreshTime";
  StorageKnownKey2["OS_VERSION"] = "os_version";
  StorageKnownKey2["USE_OS_SIMULATOR"] = "osSimulator";
  StorageKnownKey2["WORKFLOW_INTEGRATION_LOGGER_URL"] = "WORKFLOW_INTEGRATION_LOGGER_URL";
  StorageKnownKey2["OS_SIMULATOR_DATA"] = "OS_SIMULATOR_DATA";
  StorageKnownKey2["ORGANIZATION_KEY"] = "organizationKey";
  StorageKnownKey2["WIN32DEPRECATION_DEBUG"] = "win32Deprecation_debugMode";
  StorageKnownKey2["WIN32DETECTOR_STOP"] = "win32Deprecation_stop";
  StorageKnownKey2["VC_PLAYGROUND"] = "vcPlaygroundConfig";
  return StorageKnownKey2;
})(StorageKnownKey || {});

// src/infra/common/types/login.ts
var LoginMethodType2 = /* @__PURE__ */ ((LoginMethodType3) => {
  LoginMethodType3["SINGLE_SIGN_ON"] = "SINGLE_SIGN_ON";
  LoginMethodType3["INTERACTIVE_SSO"] = "INTERACTIVE_SSO";
  LoginMethodType3["CREDENTIALS"] = "CREDENTIALS";
  LoginMethodType3["SEAMLESS_LOGIN"] = "SEAMLESS_LOGIN";
  LoginMethodType3["ID_TOKEN"] = "ID_TOKEN";
  LoginMethodType3["SILENT_LOGIN"] = "SILENT_LOGIN";
  LoginMethodType3["ACCESS_TOKEN"] = "ACCESS_TOKEN";
  LoginMethodType3["REFRESH_TOKEN"] = "REFRESH_TOKEN";
  LoginMethodType3["OTP"] = "OTP";
  return LoginMethodType3;
})(LoginMethodType2 || {});
var LoginEvent2 = /* @__PURE__ */ ((LoginEvent3) => {
  LoginEvent3["PLEASE_RE_LOGIN_DISPLAYED"] = "vim_connect_re_login_displayed";
  LoginEvent3["LOGIN_NOT_DISPLAYED"] = "vim_connect_login_not_displayed";
  LoginEvent3["INITIAL_SUCCESSFUL_LOGIN"] = "vim_connect_initial_successful_login";
  LoginEvent3["INITIAL_FAILED_LOGIN"] = "vim_connect_initial_failed_login";
  LoginEvent3["SUCCESSFUL_LOGIN"] = "vim_connect_successful_login";
  LoginEvent3["FAILED_SILENT_LOGIN"] = "vim_connect_failed_silent_login";
  LoginEvent3["START_SSO_LOGIN"] = "vim_connect_start_sso_login";
  LoginEvent3["SUCCESSFUL_SSO_LOGIN"] = "vim_connect_successful_sso_login";
  LoginEvent3["FAILED_SSO_LOGIN"] = "vim_connect_failed_sso_login";
  LoginEvent3["LOGIN_CLOSED"] = "vim_connect_login_screen_closed";
  LoginEvent3["LOGIN_CLOSED_BY_USER"] = "vim_connect_login_screen_closed_by_user";
  LoginEvent3["SEAMLESS_LOGIN_START"] = "vim_connect_seamless_login_start";
  LoginEvent3["SEAMLESS_LOGIN_APPROVED"] = "vim_connect_seamless_login_approved";
  LoginEvent3["SEAMLESS_LOGIN_END"] = "vim_connect_seamless_login_end";
  LoginEvent3["DISPLAY_RE_LOGIN_SCREEN"] = "vim-ehr-display-re-login-screen";
  LoginEvent3["NON_EXISTING_SDK_USER_DETECTED"] = "non_existing_sdk_user_detected";
  LoginEvent3["USER_LOGIN"] = "vim_connect_user_login";
  LoginEvent3["USER_RE_LOGIN"] = "vim_connect_user_re_login";
  return LoginEvent3;
})(LoginEvent2 || {});
var LoginResultType = /* @__PURE__ */ ((LoginResultType2) => {
  LoginResultType2["Success"] = "success";
  LoginResultType2["Failure"] = "failure";
  LoginResultType2["Cancelled"] = "cancelled";
  return LoginResultType2;
})(LoginResultType || {});

// src/infra/common/types/smartOnFHIR.ts
var SMARTApp = /* @__PURE__ */ ((SMARTApp2) => {
  SMARTApp2["PACS"] = "PACS";
  SMARTApp2["PACSU"] = "PACSU";
  SMARTApp2["fhirSimulator"] = "fhirSimulator";
  return SMARTApp2;
})(SMARTApp || {});

// src/infra/common/poller/index.ts
var poller_exports = {};
__export(poller_exports, {
  createLockedPoller: () => createLockedPoller,
  createPoller: () => createPoller
});

// src/infra/common/poller/poller.ts
import { logger as LoggerImport } from "@getvim/vim-connect-logger";
var logger6 = LoggerImport.scope("Poller/poller.ts");
function createPoller(periodicPromise, intervalInMs = 0) {
  let isRunning = false;
  function execute() {
    if (isRunning) {
      setTimeout(() => {
        if (isRunning)
          periodicPromise().catch((error) => {
            logger6.warning("Got error while polling, continuing to poll", error);
          }).then(() => {
            execute();
          });
      }, intervalInMs);
    }
  }
  const start = () => {
    if (isRunning) {
      logger6.warning(`Poller is already running`);
    } else {
      isRunning = true;
      execute();
    }
  };
  const stop = () => {
    isRunning = false;
  };
  return { start, stop, isRunning };
}

// src/infra/common/poller/lockedPoller.ts
import { retry as retry2 } from "@vim/promise";
import { logger as LoggerImport2 } from "@getvim/vim-connect-logger";
var logger7 = LoggerImport2.scope("Poller/lockedPoller.ts");
function createLockedPoller(periodicPromise, intervalInMs = 0, onError, retryOptions) {
  let isRunning = false;
  let currentIntervalInMs = intervalInMs;
  function execute() {
    if (isRunning) {
      const promises = [
        sleep2(currentIntervalInMs),
        retry2(() => periodicPromise().catch((error) => {
          if (isRunning) {
            throw error;
          } else {
            return void 0;
          }
        }), {
          retries: 0,
          minTimeout: currentIntervalInMs,
          ...retryOptions
        })
      ];
      Promise.allSettled(promises).then((results) => {
        const error = results.find((result) => result.status === "rejected");
        if (error) {
          if (onError) {
            onError(error.reason);
          } else {
            logger7.warning("Got error while polling, continuing to poll", error.reason);
          }
        }
        if (isRunning) {
          execute();
        }
      });
    }
  }
  function sleep2(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  const start = () => {
    isRunning = true;
    execute();
  };
  const stop = () => {
    isRunning = false;
  };
  const changeInterval = (newInterval) => {
    currentIntervalInMs = newInterval;
  };
  return { start, stop, isRunning, changeInterval };
}

// src/infra/common/api/index.ts
var api_exports = {};
__export(api_exports, {
  FreeText: () => freeTextQuery_exports,
  Patient: () => patient_exports,
  Preferences: () => preferences_exports,
  Referral: () => referral_exports,
  Secrets: () => secrets_query_exports
});

// src/infra/common/api/secrets/secrets-query.ts
var secrets_query_exports = {};
__export(secrets_query_exports, {
  getUserSecrets: () => getUserSecrets
});
import gql3 from "graphql-tag";
import { logger as logger8 } from "@getvim/vim-connect-logger";
import { retry as retry3 } from "@vim/promise";
var getUserSecretsLogger = logger8.scope("Get user secrets queries");
var getUserSecretsQuery = gql3`
  query UserSecrets {
    getUserSecrets {
      sqlSecrets {
        database
        server
        user
        password
      }
    }
  }
`;
var getUserSecrets = async () => {
  try {
    const result = await retry3(async () => {
      return await gqlClient.query({
        query: getUserSecretsQuery,
        fetchPolicy: "no-cache"
      });
    }, {
      retries: 3,
      minTimeout: 200
    });
    return result?.data?.getUserSecrets;
  } catch (error) {
    getUserSecretsLogger.error("error while receiving user secrets", { error });
    return void 0;
  }
};

// src/infra/common/api/referral/index.ts
var referral_exports = {};
__export(referral_exports, {
  getReferralIdMapping: () => getReferralIdMapping,
  saveReferralIdMapping: () => saveReferralIdMapping
});

// src/infra/common/api/referral/referral-id-mapping.ts
import gql4 from "graphql-tag";
var GET_REFERRAL_ID_MAPPING_QUERY = gql4`
  query GetReferralIdMapping($input: GetReferralIdMappingInput!) {
    getReferralIdMapping(input: $input) {
      createdDate
      ehrId
      externalId
      source
    }
  }
`;
var SAVE_REFERRAL_ID_MAPPING_MUTATION = gql4`
  mutation SaveReferralIdMapping($input: SaveReferralIdMappingInput!) {
    saveReferralIdMapping(input: $input) {
      createdDate
      ehrId
      externalId
      source
    }
  }
`;
var getReferralIdMapping = async (input) => {
  const response = await gqlClient.queryAuthenticated({
    query: GET_REFERRAL_ID_MAPPING_QUERY,
    variables: { input },
    context: { uri: "/runtime/api/graphql" },
    fetchPolicy: "network-only"
  });
  const {
    data: { getReferralIdMapping: result }
  } = response;
  return result;
};
var saveReferralIdMapping = async (input) => {
  const response = await gqlClient.mutateAuthenticated({
    mutation: SAVE_REFERRAL_ID_MAPPING_MUTATION,
    variables: { input },
    context: { uri: "/runtime/api/graphql" }
  });
  return response?.data?.saveReferralIdMapping;
};

// src/infra/common/api/preferences/index.ts
var preferences_exports = {};
__export(preferences_exports, {
  getHubPosition: () => getHubPosition,
  setHubPosition: () => setHubPosition
});

// src/infra/common/api/preferences/hub-position.ts
import gql5 from "graphql-tag";
var getHubPositionQuery = gql5`
  query getHubPosition {
    getHubPosition {
      horizontal
      vertical
    }
  }
`;
var setHubPositionMutation = gql5`
  mutation setHubPosition($input: SetHubPositionInput!) {
    setHubPosition(input: $input) {
      success
    }
  }
`;
var getHubPosition = async () => {
  try {
    const deviceId = gqlClient.getDeviceId();
    const { data } = await gqlClient.queryAuthenticated({
      query: getHubPositionQuery,
      fetchPolicy: "no-cache",
      context: {
        uri: "/runtime/api/graphql",
        headers: { ...deviceId ? { ["x-vim-device-id"]: deviceId } : void 0 }
      }
    });
    const { horizontal, vertical } = data?.getHubPosition;
    return { horizontal, vertical };
  } catch (error) {
    return infra_exports.Common.Consts.DEFAULT_HUB_POSITION;
  }
};
var setHubPosition = async (hubPosition) => {
  const deviceId = gqlClient.getDeviceId();
  await gqlClient.mutateAuthenticated({
    mutation: setHubPositionMutation,
    variables: { input: { hubPosition, sentAt: new Date() } },
    context: {
      uri: "/runtime/api/graphql",
      headers: { ...deviceId ? { ["x-vim-device-id"]: deviceId } : void 0 }
    }
  });
  return;
};

// src/infra/common/api/freeTextQuery.ts
var freeTextQuery_exports = {};
__export(freeTextQuery_exports, {
  getFreeTextGQLQuery: () => getFreeTextGQLQuery
});
import gql6 from "graphql-tag";
var getFreeTextQuery = gql6`
  query QueryFreeText($input: FreeTextInput!) {
    queryFreeText(input: $input) {
      suggestions {
        cpt {
          filters {
            value {
              taxonomyCode
              taxonomyDisplayName
            }
          }
        }
        icd {
          filters {
            value {
              taxonomyCode
              taxonomyDisplayName
            }
          }
        }
        nucc {
          filters {
            value {
              taxonomyCode
              taxonomyDisplayName
            }
          }
        }
      }
    }
  }
`;
var getFreeTextGQLQuery = async (input) => {
  const { data } = await gqlClient.query({
    query: getFreeTextQuery,
    variables: { input },
    fetchPolicy: "no-cache",
    context: { uri: "/prior-auth/api/graphql" }
  });
  return data?.queryFreeText;
};

// src/infra/common/api/patient/index.ts
var patient_exports = {};
__export(patient_exports, {
  GetMember: () => get_member_exports,
  getVimPatientId: () => getVimPatientId
});

// src/infra/common/api/patient/get-member.ts
var get_member_exports = {};
__export(get_member_exports, {
  getMemberEligibilityGQLQuery: () => getMemberEligibilityGQLQuery,
  getMemberGQLQuery: () => getMemberGQLQuery,
  getMemberTokenGQLQuery: () => getMemberTokenGQLQuery
});
import gql7 from "graphql-tag";
import { logger as logger9 } from "@getvim/vim-connect-logger";
var getMemberLogger = logger9.scope("Get member queries");
var getMemberTokenQuery = gql7`
  query getMember($input: GetMemberInput!) {
    getMember(input: $input) {
      memberToken
    }
  }
`;
var getMemberQuery = gql7`
  query getMember($input: GetMemberInput!) {
    getMember(input: $input) {
      firstName
      lastName
      dateOfBirth
      memberId
      plan
      memberToken
      groupNumber
      careGaps {
        title
        notes
        providerNpi
        dateSubmitted
      }
    }
  }
`;
var getMemberTokenGQLQuery = async (input) => {
  try {
    const { data } = await gqlClient.query({
      query: getMemberTokenQuery,
      variables: { input },
      fetchPolicy: "no-cache"
    });
    return data?.getMember?.memberToken;
  } catch (error) {
    getMemberLogger.error("Failed get member query for memberToken", { error, input });
    return;
  }
};
var getMemberGQLQuery = async (input) => {
  try {
    const { data } = await gqlClient.query({
      query: getMemberQuery,
      variables: { input },
      fetchPolicy: "no-cache"
    });
    return data?.getMember;
  } catch (error) {
    getMemberLogger.error("Failed get member query", { error, input });
    return;
  }
};
var getMemberEligibilityGQLQuery = async (input) => {
  try {
    const { data } = await gqlClient.query({
      query: getMemberQuery,
      variables: { input },
      fetchPolicy: "no-cache"
    });
    return data?.getMember;
  } catch (error) {
    getMemberLogger.error("Failed get member query", { error, input });
    return;
  }
};

// src/infra/common/consts.ts
var consts_exports = {};
__export(consts_exports, {
  DEFAULT_HUB_POSITION: () => DEFAULT_HUB_POSITION,
  LOGIN_APP_NAME: () => LOGIN_APP_NAME,
  LOGIN_WIDGET_NAME: () => LOGIN_WIDGET_NAME,
  VIM_CONNECT_NOTIFICATION_WIDGET_NAME: () => VIM_CONNECT_NOTIFICATION_WIDGET_NAME,
  VIM_CONNECT_UI_APP_NAME: () => VIM_CONNECT_UI_APP_NAME,
  VIM_CONNECT_UI_TOAST_WIDGET_NAME: () => VIM_CONNECT_UI_TOAST_WIDGET_NAME,
  VIM_CONNECT_UI_TOOLTIP_WIDGET_NAME: () => VIM_CONNECT_UI_TOOLTIP_WIDGET_NAME,
  VIM_CONNECT_UI_UTILS_APP_NAME: () => VIM_CONNECT_UI_UTILS_APP_NAME,
  appNameAttribute: () => appNameAttribute,
  loginEvents: () => loginEvents,
  userNotExistReasonToDescription: () => userNotExistReasonToDescription
});
var appNameAttribute = "vim-app-name";
var LOGIN_APP_NAME = "login";
var LOGIN_WIDGET_NAME = "login-form";
var VIM_CONNECT_UI_APP_NAME = "vim-connect-ui";
var VIM_CONNECT_UI_UTILS_APP_NAME = "vim-connect-ui-utils";
var VIM_CONNECT_NOTIFICATION_WIDGET_NAME = "vim-connect-ui-notifications";
var VIM_CONNECT_UI_TOOLTIP_WIDGET_NAME = "vim-connect-ui-tooltip";
var VIM_CONNECT_UI_TOAST_WIDGET_NAME = "vim-connect-ui-toast";
var loginEvents = ["onLoggedIn"];
var DEFAULT_HUB_POSITION = {
  vertical: "High" /* High */,
  horizontal: "Right" /* Right */
};
var userNotExistReasonToDescription = {
  organization: "Organization was not identified",
  user: `User is not part of the organization`
};

// src/infra/common/utils.ts
var utils_exports = {};
__export(utils_exports, {
  TimeoutError: () => TimeoutError,
  flattenBySubstring: () => flattenBySubstring,
  getAppNameBySource: () => getAppNameBySource,
  listenAndRespondToAppMessages: () => listenAndRespondToAppMessages,
  listenToAppMessages: () => listenToAppMessages,
  listenToRuntimeMessages: () => listenToRuntimeMessages,
  sendMessageToApp: () => sendMessageToApp,
  sendMessageToRuntime: () => sendMessageToRuntime,
  sendRequestMessage: () => sendRequestMessage,
  sendRespondableMessageToRuntime: () => sendRespondableMessageToRuntime,
  sleep: () => sleep,
  timeout: () => timeout,
  urlEncodedParams: () => urlEncodedParams
});
import { v4 as uuid } from "uuid";
import { flatten } from "flat";
var sendMessageToApp = (subscriber, type, payload) => {
  subscriber.postMessage({ type, payload }, "*");
};
var listenToRuntimeMessages = (messageHandlerType, messageHandler) => {
  if (!messageHandler || !messageHandlerType)
    return;
  const onRuntimeMessage = async (browserEvent) => {
    const browserEventType = browserEvent.data?.type;
    if (browserEventType !== messageHandlerType)
      return;
    const data = browserEvent.data;
    const payload = data?.payload;
    await messageHandler({ payload });
  };
  window.addEventListener("message", onRuntimeMessage);
  return () => window.removeEventListener("message", onRuntimeMessage);
};
var sendMessageToRuntime = (type, payload) => {
  parent.postMessage({ type, payload }, "*");
};
var sendRespondableMessageToRuntime = (type, payload) => sendRequestMessage(parent, type, payload);
var sendRequestMessage = (target, type, payload) => {
  const messageId = uuid();
  return new Promise((resolve, reject) => {
    window.addEventListener("message", (message) => {
      if (message?.data?.messageId !== messageId) {
        return;
      }
      const { response, error } = message.data;
      if (error) {
        reject(error);
      } else {
        resolve(response);
      }
    });
    target.postMessage({ type, payload: { ...payload, messageId } }, "*");
  });
};
var listenToAppMessages = (messageHandlerType, messageHandler) => {
  if (!messageHandler || !messageHandlerType)
    return;
  window.addEventListener("message", async (browserEvent) => {
    const browserEventType = browserEvent.data?.type;
    if (browserEventType !== messageHandlerType)
      return;
    const source = browserEvent.source;
    const data = browserEvent.data;
    const payload = data?.payload;
    await messageHandler({ source, payload });
  });
};
var listenAndRespondToAppMessages = (messageHandlerType, messageHandler) => {
  if (!messageHandler || !messageHandlerType)
    return;
  listenToAppMessages(messageHandlerType, async (data) => {
    const { source, payload } = data;
    const { messageId } = payload ?? {};
    let response, handlerError;
    try {
      response = await messageHandler(data);
    } catch (error) {
      if (error instanceof errors_exports.StandardError) {
        handlerError = error.toJSON();
      } else {
        handlerError = new errors_exports.InternalError(error.message, {
          messageHandlerType,
          payload,
          originalError: error.originalError
        }).toJSON();
      }
    }
    source.postMessage({ messageId, response, error: handlerError }, "*");
  });
};
var getAppNameBySource = (source) => {
  if (source === window)
    return VIM_CONNECT_UI_APP_NAME;
  return source?.window?.frameElement?.getAttribute(appNameAttribute);
};
var urlEncodedParams = (params) => {
  const urlencoded = new URLSearchParams();
  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      urlencoded.append(key, params[key]);
    }
  }
  return urlencoded;
};
var sleep = (ms) => new Promise((res) => setTimeout(res, ms));
var TimeoutError = class extends Error {
  constructor() {
    super(...arguments);
    this.message = "A timeout has been reached.";
  }
};
var TIMEOUT_SYMBOL = Symbol("Timeout");
var timeout = async (promise, ms) => {
  const result = await Promise.race([promise, sleep(ms).then(() => TIMEOUT_SYMBOL)]);
  if (result === TIMEOUT_SYMBOL) {
    throw new TimeoutError();
  }
  return result;
};
var flattenBySubstring = (obj, substring) => {
  const flattenObj = flatten(obj);
  return Object.keys(flattenObj).filter((item) => item.includes(substring));
};

// src/infra/common/lts-support/index.ts
var lts_support_exports = {};
__export(lts_support_exports, {
  LATEST_VERSION: () => LATEST_VERSION,
  getCurrentPageVersion: () => getCurrentPageVersion,
  insertVersionToUrl: () => insertVersionToUrl
});

// src/infra/common/lts-support/insertVersionToUrl.ts
var insertVersionToUrl = ({ version, url }) => {
  const urlObj = new URL(url);
  const urlQuery = url.split("?")[1];
  const baseURL = `${urlObj.origin}/${version}${urlObj.pathname}`;
  return `${baseURL}${urlQuery ? `?${urlQuery}` : ""}`;
};

// src/infra/common/lts-support/getCurrentPageVersion.ts
var VERSION_PREFIX = "ver--";
var getCurrentPageVersion = () => {
  const firstURLRoute = window.location.pathname.split("/")[1];
  const isFirstURLRouteVersion = firstURLRoute.startsWith(VERSION_PREFIX);
  return isFirstURLRouteVersion ? firstURLRoute : void 0;
};

// src/infra/common/lts-support/index.ts
var LATEST_VERSION = "latest";

// src/infra/messageChannel.ts
var messageChannel_exports = {};
__export(messageChannel_exports, {
  setupParentPorts: () => setupParentPorts
});
var OS_HANDSHAKE_MESSAGE_TYPE = "vim-os-message-channel-handshake";
var HANDSHAKE_MESSAGE_TYPE = "vim-connect-message-channel-handshake";
var HANDSHAKE_MESSAGE_REPLY_TYPE = "vim-connect-message-channel-handshake-reply";
var AWAIT_CALLBACK_CHANNEL_TIMEOUT = 3e3;
var setupParentPorts = async () => {
  let setupCompleted = false;
  const params = new URLSearchParams(window.location.search);
  const useOsMessageChannel = params.get("use_os_message_channel");
  const useMessageChannel = params.get("use_message_channel");
  if (useMessageChannel !== "true" && useOsMessageChannel !== "true") {
    return Promise.resolve();
  }
  let onHandshake = void 0;
  window.addEventListener("message", (message) => {
    const port = message.ports[0];
    if (message.data.type === HANDSHAKE_MESSAGE_TYPE) {
      setupCompleted = true;
      window.$vimConnectParentPort = port;
      port.postMessage({ type: HANDSHAKE_MESSAGE_REPLY_TYPE });
      onHandshake?.();
    } else if (message.data.type === OS_HANDSHAKE_MESSAGE_TYPE) {
      window.$vimOSMessagePort = port;
      if (useOsMessageChannel && !useMessageChannel) {
        onHandshake?.();
      }
    }
  });
  return new Promise((resolve) => {
    const portToCheck = useOsMessageChannel && !useMessageChannel ? window.$vimOSMessagePort : window.$vimConnectParentPort;
    if (portToCheck) {
      resolve();
      return;
    } else {
      onHandshake = resolve;
    }
    setTimeout(() => {
      if (!setupCompleted) {
        resolve();
      }
    }, AWAIT_CALLBACK_CHANNEL_TIMEOUT);
  });
};

// src/graphql/index.ts
var graphql_exports = {};
__export(graphql_exports, {
  Auth: () => auth_exports,
  DecisionCode: () => DecisionCode
});

// src/graphql/schemas/auth/index.ts
var auth_exports = {};

// src/graphql/schemas/check-prior-auth/index.ts
var DecisionCode = /* @__PURE__ */ ((DecisionCode2) => {
  DecisionCode2[DecisionCode2["Required"] = 1] = "Required";
  DecisionCode2[DecisionCode2["NotRequired"] = 2] = "NotRequired";
  DecisionCode2[DecisionCode2["Conditional"] = 3] = "Conditional";
  DecisionCode2[DecisionCode2["Blocked"] = 4] = "Blocked";
  return DecisionCode2;
})(DecisionCode || {});

// src/widgetsMessageChannel.ts
var widgetsMessageChannel_exports = {};
__export(widgetsMessageChannel_exports, {
  setupParentPorts: () => setupParentPorts2
});
var setupParentPorts2 = async () => {
  if (window.$vimConnectParentPortSetupPromise)
    await window.$vimConnectParentPortSetupPromise;
};
export {
  adapters_exports as Adapters,
  analytics_exports as Analytics,
  common_exports as Common,
  entities_exports as Entities,
  errors_exports as Errors,
  graphql_exports as Graphql,
  infra_exports as Infra,
  login_exports as Login,
  runtime_contract_exports as RuntimeContract,
  standard_exports as Standard,
  events_exports as StandardEvents,
  widget_events_exports as WidgetEvents,
  widgetsMessageChannel_exports as WidgetsMessageChannel,
  write_backs_exports as WriteBacks
};
//# sourceMappingURL=index.js.map
